import { Redirect, Stack } from "expo-router";
import { ActivityIndicator } from "react-native";

import { CenteredScreen } from "~/components/ui";
import { AppShell } from "~/components/AppShell";
import { usePushRegistration } from "~/features/notifications/push-registration";
import { useAuth } from "~/hooks/useAuth";
import { useWorkspaceSwitcher } from "~/hooks/workspace";
import {
  canEnterApp,
  hasPaidAccess,
  isInitialOnboardingComplete,
  ONBOARDING_PATH,
  SUBSCRIBE_PATH,
} from "~/utils/onboarding";

export default function ProtectedLayout() {
  const { session, user, loading, passwordRecoveryActive } = useAuth();

  usePushRegistration();
  const workspaces = useWorkspaceSwitcher();
  const hasSharedWorkspace = workspaces.workspaces.some(
    (workspace) => workspace.owner_id !== user?.id,
  );

  if (loading || (session?.user && (!user || workspaces.isLoading))) {
    return (
      <CenteredScreen>
        <ActivityIndicator />
      </CenteredScreen>
    );
  }

  if (!session?.user) {
    return <Redirect href="/login" />;
  }

  if (passwordRecoveryActive) {
    return <Redirect href="/reset-password" />;
  }

  // First-time unpaid owners stay on the auth-style payment screen.
  // Invited teammates/accountants can enter even without a personal plan.
  if (!canEnterApp(user, { hasSharedWorkspace })) {
    return <Redirect href={SUBSCRIBE_PATH as never} />;
  }

  // Paid users finish optional business setup before the dashboard.
  if (hasPaidAccess(user) && !isInitialOnboardingComplete(user)) {
    return <Redirect href={ONBOARDING_PATH as never} />;
  }

  return (
    <AppShell>
      <Stack screenOptions={{ headerShown: false }} />
    </AppShell>
  );
}
